"use client";

import { useState } from "react";

interface Quote {
  text: string;
  author: string;
}

interface QuoteRotatorProps {
  quotes: Quote[];
}

export function QuoteRotator({ quotes }: QuoteRotatorProps) {
  const [currentQuoteIndex] = useState(() => {
    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 0);
    const diff = today.getTime() - startOfYear.getTime();
    const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
    return dayOfYear % quotes.length;
  });
  const currentQuote = quotes[currentQuoteIndex];

  return (
    <div className="stoic-quote p-4 italic">
      <p className="mb-2">
        &quot;{currentQuote.text}&quot; - {currentQuote.author}
      </p>
    </div>
  );
}
